// removed by extract-text-webpack-plugin
module.exports = {"item":"_3kJpmYAoVK5jynrJ0npr8G","selectedItem":"eXGd442HLvN5xIZEvu833 _3kJpmYAoVK5jynrJ0npr8G","name":"_3VbkhYCnINHHMVxM2OJZNf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/KpiList/style.css
// module id = 397
// module chunks = 0